<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <app-title text="Mascotas"></app-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="3">
                <b-btn variant="primary" @click="onCreatePet" v-if="userCan('create-pet')"><i class="fa fa-plus"></i> Registrar Mascota</b-btn>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-pet-filters
                    @filter="onFilter"
                ></app-pet-filters>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-pet-list
                    :table-data="tableData"
                    :on-change-page="onChangePage"
                    @sort="onSort"
                    @edit="onEdit"
                    @delete="onDelete"
                ></app-pet-list>
            </b-col>
        </b-row>
        <app-pop-up
            id="pet-form-window"
            title="Registro de Mascota"
            :on-close="onClosePetForm"
        >
            <template slot="body">
                <app-pet-form
                    ref="petForm"
                    @pet-saved="onPetSaved"
                    @pet-updated="onPetUpdated"
                    :client-id="selectedClientId"
                    :venue-id="selectedVenueId"
                ></app-pet-form>
            </template>
            <template slot="buttons">
                <b-btn variant="primary" @click="onSavePet"><i class="fa fa-save"></i> Guardar</b-btn>
            </template>
        </app-pop-up>
    </b-container>
</template>
<script>
import PetFilters from './PetListFilters';
import PetList from './PetList';
import petsRepository from '@repositories/pets.repository';
import PetForm from './PetForm';
export default {
    components: {
        appPetFilters: PetFilters,
        appPetList: PetList,
        appPetForm: PetForm
    },
    data: () => ({
        page: 1,
        sortBy: 'pets.name',
        sortDir: 'asc',
        filters: null,
        tableData: '',
        selectedPet: null
    }),
    computed: {
        selectedClientId() {
            if(this.user.profile.client_required || this.user.profile.client_side) {
                return this.client.id;
            } else {
                return null;
            }
        },
        selectedVenueId() {
            if(this.user.profile.slug === 'vigilante') {
                return this.accessPoint.venue_id;
            } else if(this.user.profile.slug === 'cliente-admin') {
                if(this.user.hasOwnProperty('venues') && this.user.venues.length === 1) {
                    return this.user.venues[0].id;
                }
            }
            return null;
        }
    },
    methods: {
        onFilter(filters) {
            this.filters = filters;
            this.page = 1;
            this.loadPets();
        },
        async loadPets() {
            const pr = {...petsRepository};
            try {
                const params = {...this.filters, page: this.page, sortBy: this.sortBy, sortDir: this.sortDir};
                if(this.user.profile.client_side || this.user.profile.slug === 'vigilante') {
                    params.clientId = this.client.id;
                }
                const {data} = await pr.get(params);
                this.tableData = data;
            } catch(err) {
                this.handleErrors(err);
            }
        },
        onChangePage(page) {
            this.page = page;
            this.loadPets();
        },
        onCreatePet() {
            // this.$bus.$emit('petForm.clear');
            this.$bus.$emit('pet-form-window.open');
        },
        onSavePet() {
            this.$refs.petForm.save();
        },
        onPetSaved(pet) {
            this.$bus.$emit('pet-form-window.close');
            this.loadPets();
        },
        onSort(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDir = ctx.sortDir;
            this.loadPets();
        },
        onEdit(pet) {
            this.$refs.petForm.fill(pet);
            this.$bus.$emit('pet-form-window.open');
        },
        onDelete(pet) {
            this.$bvModal.msgBoxConfirm('¿Esta seguro de eliminar la mascota?', {
                title: 'Confirmación',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Eliminar',
                cancelTitle: 'Cancelar',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                value && this.deletePet(pet.id);
            })
            .catch(err => {
                console.log(err);
            });
        },
        async deletePet(id) {
            const {data} = await repo.delete(`pets/${id}`);
            if(data.status) {
                this.loadPets();
            } else {
                toastr.error(data.msg);
            }
        },
        onClosePetForm() {
            this.$bus.$emit('petForm.clear');
        },
        onPetUpdated(pet) {
            const index = this.tableData.data.findIndex(item => item.id === pet.id);
            if(-1 === index) return;

            this.tableData.data.splice(index, 1, pet);
            this.$bus.$emit('pet-form-window.close');
        }
    },
    mounted() {
        this.loadPets();
    }
}
</script>